import { Capacitor } from '@capacitor/core'

// True when running inside a native Capacitor shell (iOS/Android), false in a
// regular browser (including the installed PWA).
export function isNativePlatform(): boolean {
    return Capacitor.isNativePlatform()
}

// Base URL for API calls. On native the SPA is served from the app bundle
// (capacitor://localhost / http://localhost), so API calls must target the
// remote BFF with an absolute URL. On web the SPA is same-origin as the BFF,
// so relative paths are used and this returns an empty string.
export function apiBaseUrl(): string {
    if (!isNativePlatform()) return ''
    const base = import.meta.env.VITE_API_BASE_URL
    return typeof base === 'string' ? base.replace(/\/+$/, '') : ''
}

// Resolves an app-relative API path ("/api/...") to an absolute URL on native,
// or leaves it relative on web. Non-relative inputs are returned unchanged.
export function apiUrl(path: string): string {
    if (!path.startsWith('/')) return path
    return apiBaseUrl() + path
}
